import { ToastEventBus, ToastMessageOptions } from 'primevue'

export const usePrimeVueToast = () => ({
  add: (options: ToastMessageOptions) => ToastEventBus.emit('add', { ...options, life: 3000 }),
})
